import { useLocation } from "react-router-dom";
import React from "react";
import { Card, Button } from "react-bootstrap";
import { Helmet } from "react-helmet";
import Header from "./../header";
import Footer from "./../footer";
export default function JobDetails() {
  const location = useLocation();
  const { job } = location.state;

  console.log(job);

  return (
    <>
      <Helmet>
        <title>{job.title} - Job Details</title>
        {/* Add other meta tags as needed */}
      </Helmet>
      <Header />
      <div className="container mt-4">
        <div className="row">
          <div className="col-md-12 mb-4 text-center">
            <h1 className="font-weight-bold">{job.title}</h1>
            <p className="lead">
              {job.company} - {job.location}
            </p>
            <p>{job.description}</p>
            <p>Salary: {job.salary}</p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
